export const CALENDAR_MIN_DATE = new Date('1900-01-01');
export const CALENDAR_MAX_DATE = new Date('2100-01-01');
